module.exports = __webpack_public_path__ + "img/2025big27.2eda6251.jpg";